/** Where a person made a consent decision: the consent window, the profile, or an unsubscribe link. */
export const UserConsentSource = {
  GATE: 'GATE',
  PROFILE: 'PROFILE',
  UNSUBSCRIBE_LINK: 'UNSUBSCRIBE_LINK'
} as const;

export type UserConsentSource = (typeof UserConsentSource)[keyof typeof UserConsentSource];
